import React from 'react';
import { SelectedRiskIqItem } from '@pages-clean/protocol-insights/risk-iq/review/use-risk-iq-event-handler';
import { NullableStudy } from '@contexts/local-state-context';

export interface IFormData {
    study: NullableStudy | undefined;
}

interface IContext {
    current: IFormData;
    setCurrent: React.Dispatch<React.SetStateAction<IFormData>>;
    // The CtQ/Risk type + RiskIQ id from the last RiskIQ selection-changed event (null when none
    // selected or an association is selected). Consumed by the detail/comments panel, which sends the
    // RiskIQ id as the comments' parentId.
    selectedItem: SelectedRiskIqItem | null;
}

export const ProtocolReviewContext = React.createContext<IContext>(undefined!);
